var __rspack_ns_object = JSON.parse('{"cs-follower-not-allowed":"Chỉ thêm được nhân viên đang làm ở phòng CS. Người đang phụ trách vẫn giữ hoặc bỏ được."}')